/* Rosterpress free-design forms (A, B, C): shirt-style preview image and the "Who is it for?" toggle.
   Pure helpers are shared with node tests (module.exports). Without JS the default image shows and both
   name fields stay visible; the server never blocks. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else {
    root.RPDesignForm = api;
    if (root.document) api.autoInit(root.document);
  }
})(typeof self !== 'undefined' ? self : this, function () {
  function imageForStyle(map, value, fallback) {
    map = map || {};
    return (value && Object.prototype.hasOwnProperty.call(map, value) && map[value]) || fallback || '';
  }

  /* What the form shows for a given "Who is it for?" answer. Anything but Individual counts as Team. */
  function fieldsFor(orderFor) {
    var team = orderFor !== 'Individual';
    return { showTeam: team, teamRequired: team, showPrint: !team };
  }

  function bindStylePreview(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-rp-stylepick]'), function (box) {
      if (box._rpBound) return;
      box._rpBound = true;
      var sel = box.querySelector('select');
      var img = box.querySelector('[data-rp-style-img]');
      if (!sel || !img) return;
      var fallback = img.getAttribute('src') || '';
      var map = {};
      Array.prototype.forEach.call(sel.options, function (o) {
        var u = o.getAttribute('data-img');
        if (o.value && u) map[o.value] = u;
      });
      function update() {
        var v = sel.value;
        img.src = imageForStyle(map, v, fallback);
        img.alt = v && v.indexOf('Not sure') !== 0 ? v + ' preview' : 'Bowling Jersey preview';
      }
      sel.addEventListener('change', update);
      update();
    });
  }

  function bindOrderFor(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-rp-orderfor-scope]'), function (scope) {
      if (scope._rpBound) return;
      scope._rpBound = true;
      var radios = scope.querySelectorAll('[data-rp-orderfor] input[type="radio"]');
      var teamField = scope.querySelector('[data-rp-team-field]');
      var printField = scope.querySelector('[data-rp-print-field]');
      var teamInput = teamField && teamField.querySelector('input');
      var soft = scope.hasAttribute('data-rp-soft');
      function apply() {
        var v = 'Team';
        Array.prototype.forEach.call(radios, function (r) { if (r.checked) v = r.value; });
        var f = fieldsFor(v);
        if (teamField) teamField.hidden = !f.showTeam;
        if (printField) printField.hidden = !f.showPrint;
        if (teamInput && !soft) { if (f.teamRequired) teamInput.setAttribute('required', ''); else teamInput.removeAttribute('required'); }
      }
      Array.prototype.forEach.call(radios, function (r) { r.addEventListener('change', apply); });
      if (typeof window !== 'undefined') window.addEventListener('pageshow', function (e) { if (e.persisted) apply(); });
      apply();
    });
  }

  /* Thank-you page "Email us" button (owner 17/10): the customer sends the first email, so our replies land in a thread they
     started instead of arriving cold. The form remembers its answers in sessionStorage; the thank-you page prefills a mailto. */
  var STORE_KEY = 'rp_design_request';
  var FIELDS = { 'contact[name]': 'name', 'contact[email]': 'email', 'contact[Team]': 'team', 'contact[Print name]': 'print',
    'contact[Sport]': 'sport', 'contact[Style]': 'style', 'contact[Colors]': 'colors', 'contact[Order for]': 'orderFor' };

  function requestFromFields(pairs) {
    var out = {}, other = '';
    (pairs || []).forEach(function (p) {
      var v = String(p[1] == null ? '' : p[1]).trim();
      if (p[0] === 'contact[Sport other]') other = v;
      else if (FIELDS[p[0]] && v) out[FIELDS[p[0]]] = v;
    });
    if (out.sport === 'Other' && other) out.sport = other;
    return out;
  }

  function mailtoFor(req, to) {
    req = req || {};
    var who = req.team || req.print || req.name;
    var lines = ['Hi Andy,', '', 'I just sent a design request on rosterpress.com.', ''];
    [['Team', req.team], ['Name to print', req.print], ['Shirt for', req.sport], ['Style', req.style], ['Colors', req.colors]]
      .forEach(function (l) { if (l[1]) lines.push(l[0] + ': ' + l[1]); });
    lines.push('', 'Please send my designs to this email.', '', 'Thanks,');
    if (req.name) lines.push(req.name);
    return 'mailto:' + to + '?subject=' + encodeURIComponent('Design request' + (who ? ': ' + who : '')) +
      '&body=' + encodeURIComponent(lines.join('\n'));
  }

  function storage() {
    try { return window.sessionStorage; } catch (e) { return null; }
  }

  function bindRemember(root) {
    Array.prototype.forEach.call(root.querySelectorAll('form[data-rp-upload-form]'), function (form) {
      if (form._rpRemember) return;
      form._rpRemember = true;
      function save() {
        var s = storage(); if (!s) return;
        var pairs = [];
        Array.prototype.forEach.call(form.elements, function (el) {
          if (!el.name || ((el.type === 'radio' || el.type === 'checkbox') && !el.checked)) return;
          pairs.push([el.name, el.value]);
        });
        try { s.setItem(STORE_KEY, JSON.stringify(requestFromFields(pairs))); } catch (e) { /* private mode: the button stays generic */ }
      }
      form.addEventListener('input', save); form.addEventListener('change', save); form.addEventListener('submit', save);
    });
  }

  function bindMailto(root) {
    Array.prototype.forEach.call(root.querySelectorAll('a[data-rp-mailto]'), function (a) {
      var req = {}, s = storage();
      try { req = JSON.parse((s && s.getItem(STORE_KEY)) || '{}') || {}; } catch (e) { req = {}; }
      a.href = mailtoFor(req, a.getAttribute('data-rp-mailto'));
    });
  }

  function autoInit(doc) {
    function run() { bindStylePreview(doc); bindOrderFor(doc); bindRemember(doc); bindMailto(doc); }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', run); else run();
  }

  return { imageForStyle: imageForStyle, fieldsFor: fieldsFor, requestFromFields: requestFromFields, mailtoFor: mailtoFor,
    bindStylePreview: bindStylePreview, bindOrderFor: bindOrderFor, bindRemember: bindRemember, bindMailto: bindMailto, autoInit: autoInit };
});
